import { render, staticRenderFns } from "./BelongedRedeemCode.vue?vue&type=template&id=26615a3c&scoped=true&"
import script from "./BelongedRedeemCode.vue?vue&type=script&lang=js&"
export * from "./BelongedRedeemCode.vue?vue&type=script&lang=js&"
import style0 from "./BelongedRedeemCode.vue?vue&type=style&index=0&id=26615a3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26615a3c",
  null
  
)

export default component.exports